// extracted by mini-css-extract-plugin
module.exports = {"LogoDark":"LogoDark_LogoDark__VW6RU"};